import { useField } from '@unform/core'
import { FunctionComponent, useRef, useEffect } from 'react'
import { Body1, Caption } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled from 'styled-components'
import { ErrorMessage } from './Input.css'
import { InputProps, InputPropTypes } from './InputTypes'

export const CheckboxWrapper = styled.div<{ noMargin?: boolean }>`
    & .grid {
        display: grid;
        padding: 10px 0;
        grid-gap: 10px;
        grid-template-columns: auto 1fr;
        place-items: center start;
    }

    input[type='checkbox'] {
        display: none;
    }

    input[type='checkbox'] + label:before {
        content: '';
        -webki-: none;
        background-color: transparent;
        border: 2px solid ${theme.colors.deepSeaBlue};
        border-radius: 5px;
        padding: 10px;
        height: 0px;
        width: 0px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 15px;
        margin-left: 15px;
    }

    input[type='checkbox']:checked + label:before {
        background-color: ${theme.colors.deepSeaBlue};
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 9'%3E%3Cpath fill='%23fff' d='M4.24911 6.43241L1.81661 3.99991L0.988281 4.82241L4.24911 8.08324L11.2491 1.08324L10.4266 0.260742L4.24911 6.43241z'/%3E%3C/svg%3E");
        background-position: center;
        background-repeat: no-repeat;
        background-size: fill;
        height: 0px;
        width: 0px;
    }
    .grid {
        margin: ${({ noMargin }) => (noMargin ? 0 : '-10px 0')};
        label {
            display: flex !important;
            grid-gap: 5px;
            @media (max-width: 750px) {
                grid-gap: 15px;
            }
        }
    }

    a {
        font-family: var(--font-inter);
        font-size: 12px !important;
        color: ${theme.colors.deepSeaBlue};
    }
`

interface CheckboxProps extends Omit<InputProps, 'label'> {
    label?: React.ReactNode
    onUpdate?: (value: boolean) => void
}

const Checkbox: FunctionComponent<CheckboxProps> = (props) => {
    const { name, ...rest } = props
    const inputRef = useRef(null)
    const { fieldName, defaultValue, registerField, error } = useField(name)

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'checked',
        })
    }, [fieldName, registerField])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onUpdate && props.onUpdate(e.target.checked)
    }

    return (
        <CheckboxWrapper noMargin={!!props.noMargin}>
            <div className="grid">
                <input ref={inputRef} defaultChecked={defaultValue} type="checkbox" id={name} onChange={handleInput} />
                {props.label ? (
                    <label htmlFor={name} {...rest}>
                        <Caption color={theme.colors.body1Black} fontFamily="var(--font-inter)" fontWeight={400}>
                            {props.label}
                        </Caption>
                    </label>
                ) : (
                    <label htmlFor={name} {...rest}>
                        <Body1 fontFamily="var(--font-inter)" fontWeight={400} color={theme.colors.subtitleBlack}>
                            {props.placeholder}
                        </Body1>
                    </label>
                )}
            </div>
            <ErrorMessage>{error}</ErrorMessage>
        </CheckboxWrapper>
    )
}

Checkbox.propTypes = InputPropTypes

export default Checkbox
